import initialState from './initial';

export const SlotsHistoryActionDataTypes = {
  ACTION_PROCESSING: 'ACTION_PROCESSING',
  GET_SLOTS_HISTORY_SUCCESS: 'GET_SLOTS_HISTORY_SUCCESS',
  RESET_SLOTS_HISTORY: 'RESET_SLOTS_HISTORY',
};

function reducer(state = initialState, action) {
  switch (action.type) {
    case SlotsHistoryActionDataTypes.ACTION_PROCESSING: {
      const actionProcessing = action.payload;

      if (actionProcessing !== undefined) return { ...state, actionProcessing };
      return state;
    }

    case SlotsHistoryActionDataTypes.GET_SLOTS_HISTORY_SUCCESS: {
      const history = action.payload?.list;
      const pageCount = action.payload?.pageCount;
      if (history !== undefined && pageCount !== undefined) return { ...state, history, pageCount };
      return state;
    }

    case SlotsHistoryActionDataTypes.RESET_SLOTS_HISTORY: {
      return initialState;
    }

    default:
      return state;
  }
}

export default reducer;
